import { Empty, Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import { SOCIAL_RUNS_EMPTY_TEXT, socialReasonLabel, type SocialRun } from '@/lib/social';

/**
 * REDFOX social run ledger 表（§D2/§D5/§D7）。
 * 显 run_status + normalized run_reason（源级 SLA verdict 另取自 /data-sources?include_social=true）；
 * per-row 计数即 run-level；只绑定 public 字段（0 raw 错误/限流元数据）。无行 → social-specific EmptyState。
 */
const columns: ColumnsType<SocialRun> = [
  { title: 'Run', dataIndex: 'run_id', width: 70 },
  { title: 'Week', dataIndex: 'week', width: 100, render: (w: string | null) => w ?? '—' },
  { title: '平台', dataIndex: 'platform', width: 100 },
  { title: '关键词', dataIndex: 'query', width: 140 },
  { title: '状态', dataIndex: 'run_status', width: 90, render: (s: string) => <Tag>{s}</Tag> },
  {
    title: '结果',
    dataIndex: 'run_reason',
    width: 110,
    render: (r: string | null) => socialReasonLabel(r),
  },
  { title: 'API 调用', dataIndex: 'api_call_count', width: 90, render: (v: number | null) => v ?? '—' },
  { title: '取回', dataIndex: 'items_returned', width: 80, render: (v: number | null) => v ?? '—' },
  { title: '去重后', dataIndex: 'after_dedupe', width: 80, render: (v: number | null) => v ?? '—' },
  {
    title: '写入(新/更/跳)',
    key: 'rows',
    width: 130,
    render: (_: unknown, r: SocialRun) =>
      `${r.rows_inserted ?? '—'} / ${r.rows_updated ?? '—'} / ${r.rows_skipped ?? '—'}`,
  },
  {
    title: '采集时间',
    dataIndex: 'crawl_time',
    width: 160,
    render: (t: string | null) => (t ? new Date(t).toLocaleString('zh-CN') : '—'),
  },
];

export default function SocialRunsTable({ runs, loading }: { runs: SocialRun[]; loading?: boolean }) {
  if (!loading && runs.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={SOCIAL_RUNS_EMPTY_TEXT} />;
  }
  return (
    <Table<SocialRun>
      rowKey="run_id"
      loading={loading}
      dataSource={runs}
      columns={columns}
      pagination={false}
      size="small"
      scroll={{ x: 'max-content' }}
    />
  );
}
